import { formatDate } from "_helper/utils";
import { IFormItem } from "Components/Common/Component/form/interface";
import { FORM_ERROR_MESSAGES } from "Constant";
import { useTrangThaiThanhToan } from "hook/useTrangThaiThanhToan";
import { TableColumn } from "react-data-table-component";
import { Badge } from "reactstrap";

enum LoaiTrangThaiColor {
  "Chờ thanh toán" = "info",
  "Đã thanh toán" = "success",
  "Tạm ngưng thanh toán" = "warning",
}

export const useListTableColumns = () => {
  const { data: trangThaiList } = useTrangThaiThanhToan();

  const tableColumns: TableColumn<any>[] = [
    {
      name: "Hành động",
      selector: ({ quanLyDauGia }) => "Sửa",
    },
    {
      name: "Mã xử phạt",
      selector: ({ maHoaDon }) => maHoaDon,
    },
    {
      name: "Ngày Thanh Toán",
      selector: ({ ngayThanhToan }) => formatDate(ngayThanhToan),
    },
    {
      name: "Số Tiền",
      selector: ({ soTien }) => soTien?.toLocaleString("en-US"),
    },
    {
      name: "Trạng Thái",
      selector: ({ trangThai }) => {
        const name = trangThaiList?.find(
          (item) => item.value === trangThai
        )?.name;
        return <Badge color={LoaiTrangThaiColor[name!]}>{name}</Badge>;
      },
    },
    {
      name: "Ghi Chú",
      selector: ({ ghiChu }) => ghiChu,
    },
  ];
  return { tableColumns };
};

export const useFormFields = () => {
  const { data: trangThai } = useTrangThaiThanhToan();

  return {
    formFields: [
      {
        name: "maHoaDon",
        label: "Mã Xử phạt",
        type: "input",
        rules: {
          required: FORM_ERROR_MESSAGES.REQUIRED,
        },
      },
      {
        name: "soTien",
        label: "Số Tiền",
        type: "number",
        rules: {
          required: FORM_ERROR_MESSAGES.REQUIRED,
        },
      },
      {
        name: "trangThai",
        label: "Trạng Thái",
        type: "select",
        rules: {
          required: FORM_ERROR_MESSAGES.REQUIRED,
        },
        options:
          trangThai?.map((px) => ({
            value: px.value,
            text: px.name,
          })) || [],
      },
      {
        name: "ghiChu",
        label: "Ghi Chú",
        type: "text",
        rules: {
          required: FORM_ERROR_MESSAGES.REQUIRED,
        },
      },
    ] as IFormItem[],
  };
};

export const title = "Lịch Sử Người Dùng";
export const parent = "Lịch sử thao tác";
